module.exports = __webpack_public_path__ + "static/media/fly0085.fcca1a32.webp";